export const DEFAULT_DESCRIPTION = 'otp.defaultDescription';
export const INPUT_PLACEHOLDER = 'otp.input.placeholder';
export const SUBMIT_BTN_LBL = 'otp.submitButton.label';
export const RESEND_BTN_LBL = 'otp.resendButton.label';
export const MTAN_RESENT_DESC = 'otp.mtanResent.description';
export const GENERIC_ERR_DESC = 'otp.errors.genericError.description';
export const USER_BLOCKED_ERR_DESC = 'otp.errors.userBlockedError.description';
export const EXPIRED_OTP_ERR_DESC = 'otp.errors.expiredOTPError.description';
export const INVALID_OTP_ERR_DESC = 'otp.errors.invalidOTPError.description';
